// test703
(703 && 0);
